export default ".dialog-text {\n  max-width: 98% !important;\n  width: 95% !important;\n}\n\n.dialog-container {\n  max-width: 0 !important;\n}"